import React, { useEffect, useState } from "react";
import classes from "./PublishPaperView.module.css";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Card from "../../../UI/Card/Card";
import Graybg from "../../../UI/Graybg";
import Input from "../../../UI/Input/Input";
import Select from "../../../UI/Select/Select";
import SecBTN from "../../../UI/SecBTN";
import ConfirmationModal from "../../../UI/ConfirmationModal/ConfirmationModal";
import SuccessModal from "../../../UI/SuccessModal/SuccessModal";
import BorderedSec from "../../../UI/BorderedSec";
import userService from "../../../app/services/user.service";
import PublishQues from './PublishQues'
import Loader from "../../../UI/loader/loader";
import { isEmpty, linkReplaceFn } from "../../../utils/custom_funtions";
import axios from "axios";

const PublishPaperView = () => {
  const uid = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const {pid} = useParams()
  const [searchParams] = useSearchParams();
  // searchParams.get("status")
  const [loading, setLoading] = useState(false);
  const [showAcc, setShowAcc] = useState(true);
  const [qData,setQData] = useState([])
  const [centerList,setCenterList] = useState([])
  const [classList,setClassList] = useState([])
  const [selectedCenter,setSelectedCenter] = useState('')
  const [selectedClass,setSelectedClass] = useState('')
  const [testData,setTestData] = useState({})
  const [paramData,setParamData] = useState('NA')
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  useEffect(() => {
    setParamData(searchParams.get("status"));
    
  }, []);
  useEffect(() => {
    setLoading(true)
    userService.getPublishPaperVeiw(pid,uid)
    .then((data) => {
      const datas = Object.values(data.data.data)
      const newArr = datas.map(data => {
        return {
          ...data,
          eng_option:linkReplaceFn(data.eng_option),
          h_option:linkReplaceFn(data.h_option),
          q_text:linkReplaceFn(data.q_text),
          sol_text:linkReplaceFn(data.sol_text),
          q_text_hindi:linkReplaceFn(data.q_text_hindi),
          sol_text_hindi:linkReplaceFn(data.sol_text_hindi),

        }
      }) 
      setQData(newArr);
      setTestData(newArr[0])
      setLoading(false);
      // return datas;
      return newArr;
    })
    // .then((data) =>{
    //  setTestData(data[0])
    // }
    // )
    .catch((error) => {
      setLoading(false);
      console.log(error);
    });
     
    // userService.getCenterList()
    // .then((data) => {
    //   setCenterList(data.data.data);
    // })
    // .catch((error) => {
    //   setLoading(false);
    //   console.log(error);
    // });

    // userService.getClassList()
    // .then((data) => {
    //   console.log(data.data.data);
    //   setClassList(data.data.data);
    // })
    // .then(() =>{
    //  setLoading(false)
    // }
    // )
    // .catch((error) => {
    //   setLoading(false);
    //   console.log(error);
    // });
  }, []);
  const publishHabdler = () => {
    setShowPopUp1(true);
  };
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  const yesHandler = () => {
    setShowPopUp2(true);
    setShowPopUp1(false);
  };

  const PublishPapar = () => {
    console.log("pid", pid);
    const body = {
      paper_id: pid,
      status: "PRINTED"
    };
  
    // Sending the body as the second argument in the axios.put method
    // axios.put('https://qmstest.motion.ac.in/apiseq/api/v1/paper/UpdatePaperPrintStatus', body)
    //   .then(response => {
    //     console.log('Paper published successfully:', response.data);
    //   })
    //   .catch(error => {
    //     console.error('Error publishing paper:', error);
    //   });
    userService.UpdatePaperStatus(body)
    .then(response => {
          console.log('Paper published successfully:', response.data);
        })
        .catch(error => {
          console.error('Error publishing paper:', error);
        });
  };
  
  return (
    <div className="section">
      {/* <button onClick={() => console.log(testData)}>LOG</button> */}
      {loading && <Loader />}
      <ConfirmationModal
        size="lg"
        title="Are you sure you want to Publish Paper(English Only)?"
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="Yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title="Published Paper(English Only) Successfully"
        btnTxt="Ok"
      />
      <h4>Publish Paper</h4>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/publishPaper"> Publish Paper </Link>
        </Breadcrumb.Item>
        {!isEmpty(testData?.paper_name) && (
          <Breadcrumb.Item active>{testData.paper_name}</Breadcrumb.Item>
        )}
      </Breadcrumb>
      {isEmpty(testData) && !loading ? 
        <p className="text-center">No data found</p>
       :
       <Graybg>
        <Card>
          <h5 className={classes.title}>
            {testData?.paper_name} <span>(Status : {paramData})</span>
          </h5>
          <div className={classes["publish-details"]}>
            <span>
              Session : <b>{testData.session}</b>
            </span>
            <span>
              Center : <b>{testData.center}</b>
            </span>
            <span>
              Class : <b>{testData.class}</b>
            </span>
            <span>
              Target : <b>{testData.target}</b>
            </span>
            <span>
              Format : <b>{testData.format}</b>
            </span>
          </div>
          <div className={classes["publish-details"]}>
            <span>
              Phase : <b>{testData.phase}</b>
            </span>
            <span>
              Status : <b>{paramData}</b>
            </span>
            <span>
              Exam On : <b>{testData.to_be_held_on}</b>
            </span>
            <span>
              Last Date to create paper : <b>{testData.to_be_completed_by}</b>
            </span>
          </div>
          <div className={classes["publish-details"]}>
            <span>
              Paper Requested By : <b>{testData.faculty}</b>
            </span>
            <span>
              Paper Requested On : <b>2022-03-03 16:02:02</b>
            </span>
          </div>
          <div className={classes["publish-details"]}>
            <span>
              Created By : <b>{testData.creator}</b>
            </span>
          </div>
        </Card>
        <Card
          className={classes["accordian-card"]}
          onClick={() => setShowAcc(!showAcc)}
        >
          <h4>Questions</h4>
          {showAcc ? (
            <i className="bx bx-chevron-up" style={{ fontSize: "2rem" }}></i>
          ) : (
            <i className="bx bx-chevron-down" style={{ fontSize: "2rem" }}></i>
          )}
        </Card>
        <Card style={!showAcc ? { display: "block" } : { display: "none" }}>
          <Row className="mx-0">
            {qData.map((data, i) => {
              return (
                <PublishQues
                  key={data.matrix_id}
                  qNo={data.qno}
                  qtype={data.type}
                  qid={data.qid}
                  topic={data.topic_name}
                  subTopic={data.sub_topic_name}
                  toughness={data.toughness}
                  question={data.q_text}
                  hindiQuestion={data.q_text_hindi}
                  engOption={data.eng_option}
                  hindiOption={data.h_option}
                  correctAns={data.answer}
                  answer={data.sol_text}
                  hindiAnswer={data.sol_text_hindi}
                  faculty={data.faculty}
                  sub_name={data.sub_name}
                  type={data.type}
                />
              );
            })}
          </Row>
        </Card>
        {/* <Select
          className={classes.inputs}
          style={{ marginBottom: selectedCenter == "" && "0" }}
          value={selectedCenter}
          onChange={(e) => setSelectedCenter(e.target.value)}
        >
          <option disabled value="">
            Select Center
          </option>
          {centerList.map((data) => {
            return (
              <option key={data.center_id} value={data.center_id}>
                {data.center}
              </option>
            );
          })}
        </Select>
        {selectedCenter == "" && (
          <Form.Text style={{ color: "#950202" }}>
            Please Select Center
          </Form.Text>
        )}
        <Select
          className={classes.inputs}
          style={{ marginBottom: selectedClass == "" && "0" }}
          value={selectedClass}
          onChange={(e) => setSelectedClass(e.target.value)}
        >
          <option disabled value="">
            Select Class
          </option>
          {classList.map((data) => {
            return (
              <option key={data.class_id} value={data.class_id}>
                {data.class}
              </option>
            );
          })}
        </Select>
        {selectedClass == "" && (
          <Form.Text style={{ color: "#950202" }}>
            Please Select Class
          </Form.Text>
        )} */}
        
         
            <div className={classes["sec-btn"]}>
              {/* <a
                target="_blank"
                href={`https://qmstest.motion.ac.in/apiseq/api/v1/pdf/${pid}?lang=A&issolu=0&centerid=${selectedCenter}&classid=${selectedClass}`}
              >
                <SecBTN className={classes.btns}>Publish</SecBTN>
              </a> */}
              <Link target="_blank" to={`/paper?paperid=${pid}&key=0`}>
                <SecBTN className={classes.btns} onClick={PublishPapar}>Publish Paper</SecBTN>
              </Link>
              <Link target="_blank" to={`/paper?paperid=${pid}&key=1`}>
                <SecBTN className={classes.btns} onClick={PublishPapar}>Publish Paper - English</SecBTN>
              </Link>
              <Link target="_blank" to={`/paper?paperid=${pid}&key=2`}>
                <SecBTN className={classes.btns} onClick={PublishPapar}>Publish Paper - Hindi</SecBTN>
              </Link>
              <Link target="_blank" to={`/paper?paperid=${pid}&key=1`}>
                <SecBTN className={classes.btns} onClick={PublishPapar}>Publish Paper - Board English</SecBTN>
              </Link>
              <Link target="_blank" to={`/paper?paperid=${pid}&key=3`}>
                <SecBTN className={classes.btns} onClick={PublishPapar}>Publish Paper - Board Hindi</SecBTN>
              </Link>
              
            </div>
            <div className={classes["sec-btn"]}>
              <Link target="_blank" to={`/answerkey?paperid=${pid}&key=0`}>
                <SecBTN className={classes.btns}>
                  Publish Answer Key
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/answerkey?paperid=${pid}&key=1`}>
                <SecBTN className={classes.btns}>
                  Publish Answer Board
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/answerkey?paperid=${pid}&key=2`}>
                <SecBTN className={classes.btns}>
                  Publish Question Mapping
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/answerkey?paperid=${pid}&key=3`}>
                <SecBTN className={classes.btns}>
                Publish Faculty Question Mapping
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/solution?paperid=${pid}&key=0`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Student’s Copy)
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/solution?paperid=${pid}&key=1`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Student’s Copy - English)
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/solution?paperid=${pid}&key=2`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Student’s Copy - Hindi)
                </SecBTN>
                </Link>
                <Link target="_blank" to={`/paper?paperid=${pid}&key=5`}>
                <SecBTN className={classes.btns}>
                Publish Question Single line English
                </SecBTN>
                </Link>
                <Link target="_blank" to={`/paper?paperid=${pid}&key=4`}>
                <SecBTN className={classes.btns}>
                Publish Question Single line Hindi
                </SecBTN>
                </Link>
                <Link target="_blank" to={`/solution?paperid=${pid}&key=5`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Teacher's Copy)
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/solution?paperid=${pid}&key=3`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Student’s Copy - Single Line)
                </SecBTN>
                </Link>
              <Link target="_blank" to={`/solution?paperid=${pid}&key=4`}>
                <SecBTN className={classes.btns}>
                Publish Solution(Student’s Copy - Board Exam)
                </SecBTN>
                </Link>
              {/* <a
                target="_blank"
                href={`https://qmstest.motion.ac.in/apiseq/api/v1/pdf/${pid}?lang=E&issolu=1&centerid=${selectedCenter}&classid=${selectedClass}`}
              >
                <SecBTN className={classes.btns}>
                  Publish Solution(Teacher’s Copy - English)
                </SecBTN>
              </a>
              <a
                target="_blank"
                href={`https://qmstest.motion.ac.in/apiseq/api/v1/pdf/${pid}?lang=H&issolu=1&centerid=${selectedCenter}&classid=${selectedClass}`}
              >
                <SecBTN className={classes.btns}>
                  Publish Solution(Teacher’s Copy - Hindi)   
                </SecBTN>
              </a> */}
            </div>
        
        
      </Graybg> 
       }
      
    </div>
  );
};

export default PublishPaperView;

